import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';

//Customs
import './CSS/index.css';
import './CSS/default-styles.min.css';
import './CSS/styles.min.css'
import './CSS/tools.min.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './CSS/personalizedSlick.css';

//import './CSS/slick.min.css'          //Not used so far generic import of slick-carousel are used
//import './CSS/fontawesome-v4.css';    //Not used so far

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
